import {or, RankedTester, rankWith, scopeEndsWith} from "@jsonforms/core";
import {Answer} from "@rezonence/sdk";

const responseFields: (keyof Answer)[] = ["rix", "kix"];

export const responseSelectorRendererTester: RankedTester = rankWith(6, or(
  ...responseFields.map(field => scopeEndsWith(field))
));
